import React, { PropTypes } from 'react';
import DatePicker from 'react-datepicker';
import { Col, ControlLabel, FormGroup } from 'react-bootstrap';
import { momentSetHKTimezone } from '../../../../utils/dateUtils';

const QuotationDate = (props) => {
  return (
    <FormGroup controlId="startEndDate">
      <Col componentClass={ControlLabel} sm={2}>
        {props.startDateLabel}
      </Col>
      <Col sm={4}>
         <DatePicker
            id="startDate"
            placeholderText="DD/MM/YYYY"
            dateFormat="DD/MM/YYYY"
            todayButton={'Today'}
            autoComplete="off"
            selected={props.startDate != null ? momentSetHKTimezone(props.startDate) : null}
            onChange={props.handleChangeStartDate}
            />
      </Col>
      <Col componentClass={ControlLabel} sm={2}>
        {props.endDateLabel}
      </Col>
      <Col sm={4}>
         <DatePicker
            placeholderText="DD/MM/YYYY"
            dateFormat="DD/MM/YYYY"
            todayButton={'Today'}
            autoComplete="off"
            selected={props.endDate != null ? momentSetHKTimezone(props.endDate) : null}
            onChange={props.handleChangeEndDate}
            />
      </Col>
    </FormGroup>
  )
}

QuotationDate.propTypes = {
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  startDateLabel: PropTypes.string,
  endDateLabel: PropTypes.string,
  handleChangeStartDate: PropTypes.func,
  handleChangeEndDate: PropTypes.func
};

export default QuotationDate;



// WEBPACK FOOTER //
// ./src/app/components/retrieveQuotationComponent/quotationDate/QuotationDate.js